import React from "react";
import OAuthCallbackShell from "./OAuthCallbackShell";

const buildPayload = (params) => ({
  code: params.get("code") || "",
  shop: params.get("shop") || "",
});

const ShopifyOAuthAdsCallback = () => (
  <OAuthCallbackShell
    platform="Shopify"
    endpoint="/api/ads-auth/shopify-oauth-ads/callback"
    buildPayload={buildPayload}
    redirectTo="/dashboard/connected-platforms"
  />
);

export default ShopifyOAuthAdsCallback;
